import { render, staticRenderFns } from "./CTAngiography_v1.vue?vue&type=template&id=9f285540&"
import script from "./CTAngiography_v1.vue?vue&type=script&lang=ts&"
export * from "./CTAngiography_v1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f285540')) {
      api.createRecord('9f285540', component.options)
    } else {
      api.reload('9f285540', component.options)
    }
    module.hot.accept("./CTAngiography_v1.vue?vue&type=template&id=9f285540&", function () {
      api.rerender('9f285540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/advanced/CTAngiography_v1.vue"
export default component.exports